// import React, { useMemo, useContext, useState } from 'react'
import React, { useMemo } from 'react'
import SvgTrends from '#/assets/images/icons/trends.svg'
// import { NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL } from '#/consts/neighborhood_level'
import BarGraphSkeleton from '#/containers/PropertyDetail/components/NearbyChart/skeletons/BarGraphSkeleton'
import Section from '#/containers/PropertyDetail/components/common/Section'
// import ViewModeContext from '#/contexts/ViewMode'
// import { useAbsorptionRate } from '#/hooks/useAbsorptionRate'
// import { useMarketGauge } from '#/hooks/useMarketGauge'
// import { getNeighborhood } from '#/utils/properties'
import { hasRecentMarketData } from '../../hooks/useMarketChanges'
// import AbsorptionRateCard from '../AbsorptionRate/Card'
import { Card } from '../common'
import MarketChanges from './components/MarketChanges/MarketChanges'
// import MarketConditionGauge from './components/MarketConditionGauge/MarketConditionGauge'
// import MarketConditionSelectors from './components/MarketConditionSelectors/MarketConditionSelectors'
import type { Props } from './types'
import { MarketChangesProps } from './types'

/**
 * Market Condition shows this component when the data is loading
 */
const LoadingPlaceholder: React.FC<{}> = () => (
  <>
    <Card className='h-[264px] w-[320px] space-y-5 px-5 py-4'>
      <BarGraphSkeleton size='dynamic' />
    </Card>
    <Card className='mt-[20px] h-[352px] w-[320px] space-y-5 px-5 py-6'>
      <BarGraphSkeleton size='dynamic' />
    </Card>
  </>
)
const MissingDataPlaceholder: React.FC<{}> = () => (
  <>
    <Card className='h-[264px] w-[320px] space-y-5 px-5 py-4'>
      <div className='relative mt-[40%] block w-full translate-y-[-50%] rounded-lg p-12 text-center'>
        <div className='mx-auto mb-1 flex h-12 w-12 items-center justify-center rounded-full border bg-gray-50 shadow-inner'>
          <SvgTrends className='text-gray-400 xs:h-7 xs:w-7' />
        </div>
        <span className='mx-auto mt-2 block w-[12rem] text-sm font-normal text-gray-400'>
          No market data for selected zone and property type.
        </span>
      </div>
    </Card>
    <Card className='mt-[20px] h-[352px] w-[320px] space-y-5 px-5 py-4'>
      <div className='relative mt-[50%] block w-full translate-y-[-50%] rounded-lg p-12 text-center'>
        <div className='mx-auto mb-1 flex h-12 w-12 items-center justify-center rounded-full border bg-gray-50 shadow-inner'>
          <SvgTrends className='text-gray-400 xs:h-7 xs:w-7' />
        </div>
        <span className='mx-auto mt-2 block w-[12rem] text-sm font-normal text-gray-400'>
          No market data for selected zone and property type.
        </span>
      </div>
    </Card>
  </>
)

/**
 * Render Market Condition components if there is data
 */
const MarketConditionWrapper: React.FC<MarketChangesProps> = ({
  isInCA,
  isMobile,
  marketChanges,
  range,
  zoneName,
  onDetail
}) => (
  <>
    <MarketChanges
      isInCA={isInCA}
      isMobile={isMobile}
      marketChanges={marketChanges}
      range={range}
      zoneName={zoneName}
      onDetail={onDetail}
    />
    {/* TODO: Need this datas still {isInCA && (
      <Carousel>
        <MarketConditionGauge
          marketChanges={marketChanges}
          range={range}
          zoneName={zoneName}
          onDetail={onDetail}
        />
        <AbsorptionRateCard
          marketChanges={marketChanges}
          range={range}
          onDetail={onDetail}
        />
      </Carousel>
    )} */}
  </>
)

/**
 * Show market trends section on property detail page
 * - show zone and property type selectors
 * - show carousel with market changes cards
 * - show months of inventory gauge and absoption rate card if available
 * - detemine which components to show when
 */

const MarketConditionSection: React.FC<Props> = ({
  loading,
  property,
  marketChanges,
  isMobile
  // getMarketChanges,
  // onDetail
}) => {
  // check if there is market data between now and 1 year ago
  const missingMarketChangesData = useMemo(
    () =>
      !hasRecentMarketData(marketChanges),
    [marketChanges?.data]
  )
  // check if we have the required data to display the inventory gauge
  // const showGauge = useMarketGauge(marketChanges)
  // check if we have the reuired data to show the Absorption rate card
  // const showAbsorption = useAbsorptionRate(marketChanges)

  // check if we are missing all market condition data
  // const missingMarketConditionData = !showGauge && !showAbsorption && missingMarketChangesData
  // const viewMode: TopHap.ViewMode = useContext(ViewModeContext)

  // check if property is outside CA to hide certain statistics
  const isInCA = useMemo(
    () => property.zones.find(zone => zone.type === 'state')?.name === 'California',
    [property]
  )

  // keep track of the selected geo zone, set default value
  // const [range, setRange] = useState(
  //   property.zones.find(e => e.type === 'zip')?.id ||
  //   getNeighborhood(
  //     property.zones,
  //     NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL
  //   )?.id || property.zones[0]?.id
  // )
  // keep track of property type selection, set default value
  // const [typeFilter, setTypeFilter] = useState<TopHap.TypesFilterOption['value']>({
  //   Residential: {
  //     enabled: false,
  //     subtypes: []
  //   },
  //   Commercial: {
  //     enabled: false,
  //     subtypes: []
  //   },
  //   Land: {
  //     enabled: false,
  //     subtypes: []
  //   },
  //   Other: {
  //     enabled: false,
  //     subtypes: []
  //   }
  // })

  // refetch data when zone or property type selector is changed
  // const fetchData = (range: string, typeFilter?: TopHap.TypesFilterOption['value']) => {
  //   getMarketChanges({
  //     zones: [range],
  //     filters: {
  //       and: true,
  //       filters: [
  //         {
  //           and: true,
  //           subfilters: [
  //             {
  //               metric: 'property_types',
  //               value: { ...typeFilter }
  //             }
  //           ]
  //         }
  //       ]
  //     }
  //   })
  // }
  // get the name of the selected zone
  // const zone = useMemo(() => {
  //   const selectedZone = property.zones.filter(zone => zone.id === range)[0]
  //   return (selectedZone?.name + (selectedZone?.type === 'block' || selectedZone?.type === 'tract' ? ` (${selectedZone?.type})` : ''))
  // }, [property.zones, range])
  const zone = useMemo(() => property.zones.find(e => e.type === 'zip'), [property.zones])

  // const handleTypeFilterChange = (typeFilter?: TopHap.TypesFilterOption['value']) => {
  //   setTypeFilter(typeFilter)
  //   fetchData(range, typeFilter)
  // }

  // const handleSetRange = (range: string) => {
  //   setRange(range)
  //   fetchData(range, typeFilter)
  // }
  const isLoading = loading === true

  return (
    <Section
      contentClassName='pt-2'
      description={`Historical market data near ${property.displayAddress} over selected time period.`}
      id='market'
      mode='Content'
      title='Market Trends'
    >
      {/* {viewMode === 'WEB_DETAIL_PAGE' && (
        <MarketConditionSelectors
          range={range}
          setRange={handleSetRange}
          setTypeFilter={handleTypeFilterChange}
          typeFilter={typeFilter}
          zones={property.zones}
        />
      )} */}

      {
        // if data is loading, show loader component
        isLoading ?
          <LoadingPlaceholder /> :
          // otherwise, if data is missing, show placeholer
          (
            missingMarketChangesData ?
              <MissingDataPlaceholder /> :
              // finally, if the data has loaded and there is data, show the real component
              (
                <MarketConditionWrapper
                  isInCA={isInCA}
                  isMobile={isMobile}
                  marketChanges={marketChanges}
                  range={zone?.id}
                  zoneName={zone?.name}
                  // onDetail={onDetail}
                />
              )
          )

      }
    </Section>
  )
}

export default MarketConditionSection
